import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="footer-sub-menus"
export default class extends Controller {
  connect() {
    this.topLevel = this.element.querySelector('.footer__navigation__toplevel > a')
    this.subMenu = this.element.querySelector('.footer__navigation__submenu')
    if (this.isMobile()) {
      this.arrowInsert();
    };
  }
  toggleSubMenu(event) {
    event.preventDefault()
    this.subMenu.classList.toggle('open')
    this.topLevel.classList.toggle('open')
  }
  arrowInsert() {
    const arrow = '<span data-action="click->footer-sub-menus#toggleSubMenu" class="material-symbols-outlined">keyboard_arrow_down</span>';
    this.topLevel.insertAdjacentHTML('afterend', arrow);
  }
  isMobile() {
    return window.innerWidth < 1024;
  }
}
